module.exports = __webpack_public_path__ + "img/share-orange.73ca22d.svg";